<template>
  <span>
    <small>{{ outputString }}</small>
  </span>
</template>

<script>
const date = new Date();
const weekdays = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
const months = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember'
];
export default {
  data() {
    return {
      outputString: ''
    };
  },
  created() {
    this.outputString =
      weekdays[date.getDay()] +
      ', ' +
      date
        .getDate()
        .toString()
        .padStart(2, '0') +
      '. ' +
      months[date.getMonth()] +
      ' ' +
      date.getFullYear();
  }
};
</script>

<style></style>
